export default __webpack_public_path__ + "static/media/astronaut.86ef0e9d.gif";